import { AppContent } from '../AppContent';

const smsOtp: AppContent['smsOtp'] = {
  smsOtpContent: [
    {
      serviceName: 'Online for Business',
      loaderMessage: 'Just a minute...',
      dialogTitle: 'Are you sure you want to cancel?',
      content1:
        "If you cancel now, you'll have to start your request to register again.",
      yesBtn: 'Yes, cancel',
      yesBtnLink: '/',
      cancelBtn: 'No, go back',
      sessionTimedOut: '/session-timed-out',
      smsOtpAuthorize: '/sms-otp/authorise',
      technicalErrorPage: '/technical-error',
      unableToVerify: '/unable-to-verify',
    },
  ],
};

export default smsOtp;
